import { Item, ItemContent, ItemHeader, ItemTitle } from '@ibsys/kit';
import { LockIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { KmEntityType } from '@/entities/ontology';
import { Tooltip } from '@/shared/ui';

type Props = {
  entityType: KmEntityType;
  isActive: boolean;
};

/**
 * Элемент списка типов сущностей: название, код и признак системного типа.
 */
export const EntityTypeListItem: FC<Props> = ({ entityType, isActive }) => {
  const { t } = useTranslation('ontology');
  const navigate = useNavigate();

  return (
    <li role="button" tabIndex={-1} onClick={() => navigate(`/ontology/${entityType.code}`)}>
      <Item variant={isActive ? 'muted' : 'outline'} className="hover:bg-muted cursor-pointer">
        <ItemHeader>
          <ItemTitle className="flex flex-wrap items-center gap-2">
            <span className="whitespace-normal break-words">{entityType.name}</span>
            {/* Системный тип — иконкой (правка запрещена), не текстовой колонкой */}
            {entityType.isSystem && (
              <Tooltip tooltip={t('systemType')}>
                <LockIcon className="size-3.5 text-muted-foreground shrink-0" aria-label={t('systemType')} />
              </Tooltip>
            )}
          </ItemTitle>
        </ItemHeader>
        <ItemContent>
          {/* В левой панели — только код; описание и счётчик атрибутов показываем в детальной карточке справа */}
          <span className="font-mono text-sm text-muted-foreground break-all">{entityType.code}</span>
        </ItemContent>
      </Item>
    </li>
  );
};
